export default __webpack_public_path__ + "static/signature-8eaf52f75d05f5fb5aa6d1a4fc7d20a4.png";